<div class="totalContainer">
  <section class="top-bg">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <div class="col-lg-6" data-aos="fade-down">
          <div class="name">
            You Are Invited By : <b class="yelow-txt">{{ userName }}</b>
          </div>
        </div>

        <div class="col-lg-6" data-aos="fade-down">
          <div class="sign-area">
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="btn btn-sign go"
              role="button"
              >Sign Up</a
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="banner-bg">
    <div class="container">
      <div class="row">
        <div
          class="col-lg-6"
          data-aos="fade-right"
          data-aos-offset="100"
          data-aos-easing="ease-in-sine"
        >
          <h2 class="under-line">A mind-blowing</h2>
          <h1 class="text-uppercase">business concept</h1>
          <h3>with residual income</h3>

          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="btn btn-primary text-uppercase w-100"
            role="button"
            >BECOME A FOUNDER NOW</a
          >
        </div>
      </div>
    </div>
  </section>
  <section class="sec-bg text-white">
    <div class="container">
      <div class="row justify-content-center">
        <div
          class="col-lg-11"
          data-aos="fade-left"
          data-aos-offset="100"
          data-aos-easing="ease-in-sine"
        >
          <h2>Good day 'FUTURE' Founder</h2>

          <p>
            Ever wondered what would life be if you got a smart marketing
            solution that guarantees lifetime residual income? <br />

            Great right!! Presenting.. Something very POWERFUL.. A self-driven
            business opportunity that is a complete package to provide you
            profitability.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="sec_three">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <div
          class="col-lg-6 left-txt-area"
          data-aos="fade-right"
          data-aos-offset="100"
          data-aos-easing="ease-in-sine"
        >
          <h2>Are you new to Internet Marketing?</h2>
          <p>
            Sit back and enjoy the ride as the technology will go out and find
            the traffic, filter the traffic, bring the eyeballs, help people
            close and bring in to the business.
          </p>

          <p>
            In the video on the right, visionary Mr. Mufareh explains several
            issues that we find difficult to overcome in our life. However, he
            also explains his strategies and plans that will help you to
            overcome these obstacles easily.
          </p>

          <h4>
            Change your direction of life.. Your destination will automatically
            change
          </h4>

          <p>
            It's not a 'copy-cat' or 'look-alike' product. It has been
            meticulously developed from the ground up using artificial
            intelligence.
          </p>

          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="btn btn-primary text-uppercase w-100"
            role="button"
            >BECOME A FOUNDER NOW</a
          >
        </div>

        <div class="col-lg-6">
          <div
            class="video-area-1"
            data-aos="flip-left"
            data-aos-easing="ease-in-sine"
          >
            <div class="play_button">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/invitation13_2/images/play_button.png"
                class="img-fluid"
                alt="image"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#myModal1"
              />
            </div>
            <img
              src="
{{ myLinksS3URL }}frontend/invitationfive/images/greeting1.png"
              alt=""
              class="img-fluid video-bg-1"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="sec_four">
    <div class="container">
      <div class="row justify-content-center">
        <div
          class="col-lg-11"
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine"
        >
          <h3>
            Yes!! The concept is magical.. The concept is fresh.. The concept is
            amazing with its
          </h3>

          <ul class="ab">
            <li>Technology</li>
            <li>Fairness</li>
            <li>Features</li>
          </ul>

          <h3>
            Please go through the video below as you will gain more knowledge on
            the income plan and strategy of visionary Mr. Mufareh. This is the
            goldmine of a lifetime residual income.
          </h3>
        </div>
      </div>
    </div>
  </section>
  <section
    class="sec_five align-items-center"
    data-aos="zoom-in-down"
    data-aos-offset="100"
  >
    <div class="row">
      <div class="col-lg-12">
        <div class="play_button">
          <img
            src="{{
              myLinksS3URL
            }}frontend/invitation13_2/images/play_button.png"
            class="img-fluid"
            alt="image"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target="#myModal2"
          />
        </div>

        <img
          src="{{ myLinksS3URL }}frontend/presentation22/images/video-bg-1.jpg"
          alt=""
          class="img-fluid video-bg-2 w-100"
        />
      </div>
    </div>
  </section>
  <section class="sec_six text-white">
    <div class="container-fluid">
      <div class="row no-gutter justify-content-center">
        <div
          class="col-lg-5 blue-bg"
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="300"
        >
          <h3 class="green-txt">We are present in more than 100 countries!</h3>

          <h4>We are the new world standard, fully legal and complaint</h4>

          <ul class="bc">
            <li>Use own domain to build your business</li>
            <li>Own dashboard to control and monitor</li>
            <li>No office required. Work from home</li>
            <li>Instant payment directly in your account</li>
          </ul>
        </div>

        <div
          class="col-lg-7 yelow-bg"
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="300"
        >
          <h2>
            Change your life today. Don't gamble on the future, act now, without
            delay.
          </h2>

          <p>
            Pay only $97 to join which otherwise costs $977. Avail this 90%
            discount as a pre-launch offer. You can obviously join us later but
            there is no guarantee on the availability of seats.
          </p>

          <p>
            This is a true marketer's miracle and technologically the first of
            its kind. Secure your ultimate residual income opportunity with real
            people.
          </p>

          <div class="row">
            <div class="col-lg-10">
              <a
                [routerLink]="'.'"
                [queryParams]="{ reg: referralId }"
                [fragment]="'regform'"
                class="btn btn-primary text-uppercase w-100"
                role="button"
                >BECOME A FOUNDER NOW</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="seven-area">
    <div class="container-fluid">
      <div class="col-lg-12">
        <div
          class="row align-items-center text-center"
          data-aos="zoom-out"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine"
        >
          <div class="col-lg-7">
            <div class="play_button">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/invitation13_2/images/play_button.png"
                class="img-fluid"
                alt="image"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#myModal3"
              />
            </div>

            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation22/images/video-bg-2.png"
              alt=""
              class="img-fluid video-bg-3 w-100"
            />
          </div>

          <div class="col-lg-5 text-left">
            <h2>How can you take advantage of this NEW TECHNOLOGY?</h2>

            <p>
              You get the three main pillars of success. A viable business, an
              efficient tool set that is set on auto pilot, fuelled with endless
              and unlimited amount of traffic and visitors to your business. You
              choose what to sell and what to recruit.
            </p>

            <p>
              You also get a safe platform to build any business because
              businesses can be changed inside of the platform without changing
              the brand. Once you have the brand, it is permanent. You can
              add/remove as you wish any business any time.
            </p>

            <div class="row">
              <div class="col-lg-10">
                <a
                  [routerLink]="'.'"
                  [queryParams]="{ reg: referralId }"
                  [fragment]="'regform'"
                  class="btn btn-primary text-uppercase w-100"
                  role="button"
                  >BECOME A FOUNDER NOW</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="eight-area">
    <div class="container-fluid">
      <div class="row no-gutter">
        <div
          class="col-lg-6 left-area"
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="300"
        >
          <h2>
            Registering with <samp class="green-txt-2"> O-Founders</samp> is
            very easy:
          </h2>

          <ul class="dc">
            <li>Click on 'Become a Founder'</li>
            <li>Fill up the registration form</li>
            <li>Pay using Card or Bitcoin</li>
          </ul>

          <h3 class="green-txt-2">You are now a Founder!</h3>
        </div>

        <div
          class="col-lg-6 yelow-bg"
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="300"
        >
          <h1 class="text-white">WEBINAR</h1>
          <h3>UPCOMING WEBINAR</h3>

          <div class="row">
            <div class="col-lg-10">
              <a
                class="btn btn-primary-2 text-uppercase w-100"
                href="#"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#previous"
                role="button"
              >
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation22/images/play-btn.png"
                  alt=""
                  class="img-fluid"
                />
                PREVIOUS WEBINAR PLAYBACK</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!------------------------------------------------------------------------->

  <section class="nine-area">
    <div class="container text-center">
      <div
        class="row justify-content-end"
        data-aos="zoom-in-down"
        data-aos-easing="linear"
        data-aos-duration="1000"
      >
        <!--                <img src="images/form-bg.png" alt="" class="img-fluid m-auto">-->

        <div class="col-lg-12" id="regform">
          <img
            src="{{ myLinksS3URL }}frontend/presentation22/images/logo.png"
            alt=""
            class="img-fluid m-auto logo-2"
          />

          <div class="reg-text my-3">REGISTER</div>

          <!-- <div class="alert-success">


                                    <strong>Success!</strong> 

                                </div> -->

          <div class="panel-group cst"></div>
        </div>

        <div class="col-lg-8 m-auto">
          <form [formGroup]="registerForm" class="registerForm">
            <div class="row reg">
              <div class="col-md-6">
                <div class="d-block form-group">
                  <input
                    matInput
                    type="text"
                    class="form-control"
                    placeholder="First Name"
                    formControlName="firstname"
                    required
                  />
                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError('required') &&
                      registerForm.controls['firstname'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    First Name Required.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError('maxlength')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Min 1, max 50 characters.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containOnlyNumbers'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only numbers are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containOnlySpecialChars'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only special characters are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveSpaces'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive spaces are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveDots'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dots are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveHyphens'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dashes are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveUnderScores'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive underscores are not allowed.
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-block form-group">
                  <input
                    matInput
                    type="text"
                    placeholder="Last Name"
                    class="form-control"
                    formControlName="lastname"
                    required
                  />
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError('required') &&
                      registerForm.controls['lastname'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Last Name Required.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError('maxlength')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Min 1, max 50 characters.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containOnlyNumbers'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only numbers are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containOnlySpecialChars'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only special characters are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveSpaces'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive spaces are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveDots'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dots are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveHyphens'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dashes are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveUnderScores'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive underscores are not allowed.
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="d-block form-group">
                  <input
                    matInput
                    type="text"
                    placeholder="Email Id"
                    class="form-control"
                    formControlName="email"
                    required
                  />

                  <span
                    *ngIf="
                      registerForm.controls['email'].hasError('required') &&
                      registerForm.controls['email'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Email id Required.
                  </span>
                  <span
                    *ngIf="registerForm.controls['email'].hasError('pattern')"
                    class="failed-validation"
                    style="color: red"
                  >
                    Please enter valid email.
                  </span>
                  <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                                 class="failed-validation" style="color: red">
                                  Email length sould be less than 100.
                                </span>-->
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group d-block">
                  <div class="password-block">
                    <input
                      matInput
                      placeholder="Password"
                      formControlName="password"
                      class="log_in_fild form-control"
                      [type]="pwdToggle ? 'text' : 'password'"
                      required
                    />
                    <button
                      type="button"
                      class="password-icon"
                      (click)="pwdToggle = !pwdToggle"
                    >
                      <i
                        class="fal"
                        [ngClass]="{
                          'fa-eye': pwdToggle,
                          'fa-eye-slash': !pwdToggle
                        }"
                      ></i>
                    </button>
                  </div>
                  <span
                    *ngIf="
                      registerForm.controls['password'].hasError('required') &&
                      registerForm.controls['password'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Password Required
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['password'].hasError('pattern')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Password should contain minimum 8 Characters and Atleast one
                    Uppercase, One Lowercase, one Number and one Special
                    Characters
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="d-block form-group">
                  <input
                    matInput
                    type="text"
                    placeholder="Phone Number"
                    class="form-control"
                    formControlName="phone"
                    onKeyPress="if(this.value.length==20) return false;"
                    onkeydown="return event.keyCode !== 69"
                    required
                  />
                  <span
                    *ngIf="
                      registerForm.controls['phone'].hasError('required') &&
                      registerForm.controls['phone'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Phone number is required.
                  </span>
                  <span
                    *ngIf="registerForm.controls['phone'].hasError('pattern')"
                    class="failed-validation"
                    style="color: red"
                  >
                    Only numbers are allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['phone'].hasError('minlength') ||
                      registerForm.controls['phone'].hasError('maxlength')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Min 6 and max 20 digits.
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-block form-group">
                  <select
                    formControlName="country_id"
                    required
                    class="form-control"
                  >
                    <option value="">Select Country</option>
                    <option
                      *ngFor="let country of countriesList"
                      [value]="country.countryId"
                    >
                      {{ country.countryName }}
                    </option>
                  </select>
                  <span
                    *ngIf="
                      registerForm.controls['country_id'].hasError(
                        'required'
                      ) && registerForm.controls['country_id'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Plese Select Country
                  </span>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <div class="row no-gutters">
                    <div class="capcha form-control">
                      <img [src]="imageCaptcha" style="width: 120px" />
                    </div>

                    <div class="refresh-icn">
                      <i
                        class="fa fa-refresh fa-lg"
                        aria-hidden="true"
                        (click)="regenerateCaptcha()"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <div class="main input-effect">
                    <input
                      id="capcha"
                      maxlength="5"
                      name="capcha"
                      type="text"
                      formControlName="enteredCaptcha"
                      placeholder=" Enter Captcha"
                      class="form-control effect-19"
                      required="required"
                    />
                    <span
                      *ngIf="
                        registerForm.controls['enteredCaptcha'].hasError(
                          'required'
                        ) && registerForm.controls['enteredCaptcha'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Captcha Required
                    </span>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="text-center">
              <button
                mat-raised-button
                type="submit"
                (click)="submitRegister()"
                [disabled]="registerForm.invalid"
                class="ibtn w-100"
              >
                SignUp
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>

  <!--------------------------------->

  <section class="ten-sec">
    <div class="container">
      <div class="row">
        <div
          class="col-lg-12"
          data-aos="zoom-in-down"
          data-aos-easing="linear"
          data-aos-duration="1000"
        >
          <h1>Wait.. There is something more that you will be getting!!</h1>

          <p>
            If you have a good business, a good product, a legit business model,
            we are going to assist them to be unstuck or to duplicate finally or
            to have a higher retention. This is the last business or marketing
            platform that you need.
          </p>

          <p>
            We are an income opportunity even for those who do not have a
            business. Hence, there is an income plan which is one of a kind. The
            database, the people that you have added, they are going to be in
            your business which is the true residual business model.
          </p>

          <h1>Already a Founder?</h1>
        </div>

        <div class="col-lg-6">
          <a
            class="btn btn-primary text-uppercase w-100"
            routerLink="/auth/login"
            role="button"
            target="_blank"
            rel="noopener"
            >Sign In</a
          >
        </div>
      </div>
    </div>
  </section>

  <!------------------------------------------------------------->
  <section class="eleven-area blue-bg">
    <div class="demo">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div id="testimonial-slider" class="slick">
              <ngx-slick-carousel
                class="carousel"
                #slickModal="slick-carousel"
                [config]="slideConfig"
                (init)="slickInit($event)"
              >
                <div ngxSlickItem class="testimonial">
                  <h2>THIS IS A WINNER for sure!</h2>
                  <h3 class="title">Mike Williams</h3>
                  <div class="pic">
                    <img
                      src="{{
                        myLinksS3URL
                      }}frontend/presentation17/images/t4.png"
                      alt=""
                    />
                  </div>
                  <div class="testimonial-content">
                    <p class="description">
                      I want to personally say thank you to everyone on this
                      awesome journey that Ash Murareh has created. As many of
                      you may not know, Ash is a very successful online marketer
                      and has made his living in this industry building massive
                      teams for various companies. He saw a big need for
                      creating a company that would help the average person
                      succeed online so he decided to build it himself. When you
                      listen to his Founder's presentations or when you speak
                      with him, you will immediately feel his passion to build a
                      highly effective business where every single person will
                      be successful.
                    </p>
                  </div>
                </div>
                <div ngxSlickItem class="testimonial">
                  <h2>THIS IS A WINNER for sure!</h2>

                  <h3 class="title">TIM LEACH</h3>

                  <div class="pic">
                    <img
                      src="{{
                        myLinksS3URL
                      }}frontend/presentation17/images/t1.png"
                      alt=""
                    />
                  </div>
                  <div class="testimonial-content">
                    <p class="description">
                      His drive and passion for creating a platform to help
                      everyone from seasoned marketers to the "little guy"
                      helped solidify my belief Then learning how we benefit
                      financially with optional starting points, makes this an
                      ideal model for anyone with a business who needs
                      advertising. <br />

                      Thank you Ash for your vision and help for so many people
                      around the world.
                    </p>
                  </div>
                </div>

                <div ngxSlickItem class="testimonial">
                  <h2>THIS IS A WINNER for sure!</h2>
                  <h3 class="title">PRINCE OBI</h3>

                  <div class="pic">
                    <img src="{{ cloudFrontUrl }}uploads/t2.png" alt="" />
                  </div>
                  <div class="testimonial-content">
                    <p class="description">
                      In my 19 years successful career in this space,I have
                      never seen a business so full, so disruptive, so
                      intriguing that everyone I approach is excited to belong.
                      <br />

                      Did a Facebook post, alongside my WhatsApp campaign, on
                      the founder position, that attracted 122 comments, 14
                      people have joined direct to me and in less than 48 hours,
                      59 super qualified leads have submitted their email,
                      requesting information to be founders, AND ALL THESE
                      WITHOUT ANYTHING YET ONGROUND, not even a website. I am
                      totally blown away and will build my final dynasty here in
                      ONPASSIVE.
                    </p>
                  </div>
                </div>
              </ngx-slick-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div id="myModal1" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="first_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video1.pause(); video1.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video1
          id="my-video"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/invitationfive/images/greeting1-new.png"
        >
          <source
            src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
            type="video/mp4"
          />

          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>

  <div id="myModal2" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="second_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video2.pause(); video2.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video2
          id="my-video1"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/greetingsgofound/images/greeting2.png"
        >
          <source
            src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
            type="video/mp4"
          />

          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>

  <div id="myModal3" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="third_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video3.pause(); video3.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video3
          id="my-video2"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/invitationfive/images/greeting3-new.png"
        >
          <source
            src="{{
              myLinksS3URL
            }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
            type="video/mp4"
          />

          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>

  <div id="previous" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            id="prev_video_pause"
            (click)="video4.pause(); video4.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video4
          width="100%"
          class="video-js"
          controls
          preload="auto"
          poster="{{ myLinksS3URL }}videos/title.jpg"
          id="my-video"
        >
          <source
            src="{{
              myLinksS3URL
            }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
            id="video"
            type="video/mp4"
          />

          Your browser does not support HTML5 video.
        </video>
      </div>
    </div>
  </div>

  <footer>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          Get the Founders position now as seats are still available. HURRY UP!
        </div>
      </div>
    </div>
  </footer>
</div>
